import type { LexicalNode } from "lexical";

export function $replaceWithMultiple(node: LexicalNode, newNodes: LexicalNode[]): void {
  const parent = node.getParentOrThrow();

  const index = node.getIndexWithinParent();

  parent.splice(index, 1, newNodes);
}
